import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useLocation } from 'react-router-dom';
import { AccountContext } from '../../components/AccountContext';
import TeamReportList from './TeamReportList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query TeamReports(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: TeamReportFilter
    $sort: TeamReportSortSpecifier
  ) {
    account(id: $accountId) {
      id
      teamReports(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            teamName
            numberOfAssessments
            createdOn
            updatedOn
            createdBy {
              firstName
              lastName
            }
            template {
              id
              title
            }
          }
        }
      }
    }
  }
`;

const TeamReportListContainer = () => {
  const currentAccount = useContext(AccountContext);
  const location = useLocation();
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };
  return (
    <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
      {({ data, loading, error }) => {
        if (error) return `Error! ${error.message}`;

        const connection = data && data.account ? data.account.teamReports : emptyConnection();

        return <TeamReportList connection={connection} loading={loading} />;
      }}
    </Query>
  );
};

export default TeamReportListContainer;
